import { LoaderService } from './../services/loader.service';
import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';

export const HIDE_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private readonly loaderService: LoaderService = inject(LoaderService);

  private excludedDomains = ['/assets', 'onelogin.com', 'maps.googleapis.com'];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.excludedDomains.some(d => request.url.includes(d))) return next.handle(request);

    const hideLoader = request.context.get(HIDE_LOADER);

    if (hideLoader) return next.handle(request);

    this.loaderService.show(request.url);

    return next.handle(request).pipe(
      finalize(() => {
        this.loaderService.hide(request.url);
      })
    );
  }
}
